export default "__VITE_ASSET__BqSQAR6D__"